export interface SocialAccountRemoveMenuProps {
  onRemoveAccount: VoidFunction;
}

export const SOCIAL_ACCOUNT_REMOVE_MENU_REMOVE_ITEM_ID = 'social-account-remove-menu-remove';
